<template>
  <v-layout>
    <div class="detail-layout">
      <div class="detail-title">
        <span>{{ detailTitle }}</span><br/>
        <span>{{ memberInfo }}</span>
      </div>

      <div class="detail-blue-layout">
        <span>인카모기지 주식회사</span>
        <span>지급일: {{ formatSimpleDate(detailData.paymentYmd) }}</span>
      </div>

      <div class="detail-table-layout">
        <table>
          <tr>
            <th class="t-1" colspan="1">성명</th>
            <th class="t-3 yellow-row" colspan="3">{{ detailData.memberNm }}</th>
            <th class="t-3" colspan="3">주민번호</th>
            <td class="t-3" colspan="3">{{ setSsnoMasking(detailData.ssno) }}</td>
          </tr>
          <tr>
            <th class="t-1" colspan="1">팀</th>
            <td class="t-3" colspan="3">{{ detailData.orgNm }}</td>
            <th class="t-3" colspan="3">모집인번호</th>
            <td class="t-3" colspan="3">{{ setLoanBrokerNoFormat(detailData.loanBrokerNo) }}</td>
          </tr>
          <tr>
            <th class="t-1" colspan="1">본부장</th>
            <td class="t-3" colspan="3">{{ checkMgrYn(detailData.headMgrYn) }}</td>
            <th class="t-1" colspan="1">관리팀장</th>
            <td class="t-2" colspan="2">{{ checkMgrYn(detailData.managementMgrYn) }}</td>
            <th class="t-1" colspan="1">영업팀장</th>
            <td class="t-2" colspan="2">{{ checkMgrYn(detailData.salesMgrYn) }}</td>
          </tr>
          <tr>
            <th class="grey-row" colspan="10">세부 내역</th>
          </tr>
          <tr>
            <th colspan="5">지 급</th>
            <th colspan="5">공 제</th>
          </tr>
          <tr>
            <td colspan="3">수수료 항목</td>
            <td colspan="2">지급 금액</td>
            <td colspan="2">공제 항목</td>
            <td colspan="3">공제 금액</td>
          </tr>
          <tr>
            <td rowspan="16" colspan="1">지급 정보<br/>(VAT후)</td>
            <th class="grey-row" colspan="2">수수료총액</th>
            <th class="grey-row num-text" colspan="2">{{ inputComma(detailData.sumCommission) }}</th>
            <td colspan="2">소득세</td>
            <td class="num-text" colspan="3">{{ inputComma(detailData.incomeTaxAmount) }}</td>
          </tr>
          <tr>
            <th colspan="2">팀원수수료</th>
            <td class="num-text" colspan="2">{{ inputComma(detailData.teamMemberCommission) }}</td>
            <td colspan="2">지방소득세</td>
            <td class="num-text" colspan="3">{{ inputComma(detailData.localTaxAmount) }}</td>
          </tr>
          <tr>
            <th colspan="2">영업팀장수수료</th>
            <td class="num-text" colspan="2">{{ inputComma(detailData.salesMgrCommission) }}</td>
            <td colspan="2">고용보험</td>
            <td class="num-text" colspan="3">{{ inputComma(detailData.employmentInsuranceAmount) }}</td>
          </tr>
          <tr>
            <th colspan="2">관리팀장수수료</th>
            <td class="num-text" colspan="2">{{ inputComma(detailData.managementMgrCommission) }}</td>
            <td colspan="2">산재보험</td>
            <td class="num-text" colspan="3">{{ inputComma(detailData.industrialAccidentInsuranceAmount) }}</td>
          </tr>
          <tr>
            <th colspan="2">본부장수수료</th>
            <td class="num-text" colspan="2">{{ inputComma(detailData.headMgrCommission) }}</td>
            <td colspan="2">대여금</td>
            <td class="num-text" colspan="3">{{ inputComma(detailData.loanDeductionAmount) }}</td>
          </tr>
          <tr>
            <th colspan="4"></th>
            <td colspan="2">기타</td>
            <td class="num-text" colspan="3">{{ inputComma(detailData.sumOther) }}</td>
          </tr>
          <tr>
            <th class="grey-row" colspan="2">지원금 총액</th>
            <th class="grey-row num-text" colspan="2">{{ inputComma(detailData.sumCost) }}</th>
            <td colspan="2">두루누리지원금</td>
            <td class="num-text" colspan="3">{{ inputComma(detailData.dualSupportAmount) }}</td>
          </tr>
          <tr>
            <td colspan="2">운영비지원금</td>
            <td class="num-text" colspan="2">{{ inputComma(detailData.operatingCost) }}</td>
            <td colspan="2">오차금액 정산</td>
            <td class="num-text" colspan="3">{{ inputComma(detailData.adjustmentDifferenceAmount) }}</td>
          </tr>
          <tr>
            <td colspan="2">리크루팅지원금</td>
            <td class="num-text" colspan="2">{{ inputComma(detailData.recruitingCost) }}</td>
            <td colspan="5" rowspan="8"></td>
          </tr>
          <tr>
            <td colspan="2">정착지원금</td>
            <td class="num-text" colspan="2">{{ inputComma(detailData.settlementSupportAmount) }}</td>
          </tr>
          <tr>
            <th colspan="4"></th>
          </tr>
          <tr>
            <th class="grey-row" colspan="2">기타</th>
            <th class="grey-row num-text" colspan="2">{{ inputComma(detailData.sumOther) }}</th>
          </tr>
          <tr>
            <td colspan="2">상품권시상</td>
            <td class="num-text" colspan="2">{{ inputComma(detailData.giftCardAwardAmount) }}</td>
          </tr>
          <tr>
            <td colspan="2">여행시상</td>
            <td class="num-text" colspan="2">{{ inputComma(detailData.annualAwardAmount) }}</td>
          </tr>
          <tr>
            <td colspan="2">기타</td>
            <td class="num-text" colspan="2">{{ inputComma(detailData.otherAmount) }}</td>
          </tr>
          <tr>
            <th colspan="4"></th>
          </tr>
          <tr>
            <th class="grey-row" colspan="3">지급액 계</th>
            <th class="grey-row num-text" colspan="2">{{ inputComma(detailData.sumPaymentAmount) }}</th>
            <th class="red-row" colspan="2">공제액 계</th>
            <th class="red-row num-text" colspan="3">{{ inputComma(detailData.totalDeductionAmount) }}</th>
          </tr>
          <tr>
            <td class="not-border-bottom" colspan="5"></td>
            <th class="blue-row" colspan="2">실수령액</th>
            <th class="blue-row num-text" colspan="3">{{ inputComma(detailData.realPayAmount) }}</th>
          </tr>
          <tr>
            <td class="not-border-top" colspan="9"></td>
          </tr>
          <tr>
            <th class="grey-row text-left" colspan="10">계산 방법</th>
          </tr>
          <tr>
            <td class="grey-row" colspan="3">구분</td>
            <td class="grey-row" colspan="2">산출기준</td>
            <td class="grey-row" colspan="2">요율</td>
            <td class="grey-row" colspan="3">지급액</td>
          </tr>
          <tr>
            <td colspan="3">소득세</td>
            <td colspan="2">지급액 계</td>
            <td colspan="2">{{ toPercent(detailData.incomeTaxRate, 2) }}</td>
            <td class="num-text" colspan="3">{{ inputComma(detailData.realIncomeTaxAmount) }}</td>
          </tr>
          <tr>
            <td colspan="3">지방소득세</td>
            <td colspan="2">소득세</td>
            <td colspan="2">{{ toPercent(detailData.localTaxRate, 2) }}</td>
            <td class="num-text" colspan="3">{{ inputComma(detailData.realLocalTaxAmount) }}</td>
          </tr>
          <tr>
            <td colspan="3">고용보험 (개인부담분)</td>
            <td rowspan="2" colspan="2">월보수액<br/>(지급액 계 * <span class="red--text">{{ toPercent(detailData.commissionRate, 1) }}</span>)</td>
            <td class="red--text" colspan="2">{{ toPercent(detailData.employmentInsuranceRate, 2) }}</td>
            <td class="num-text" colspan="3">{{ inputComma(detailData.realEmploymentInsuranceAmount) }}</td>
          </tr>
          <tr>
            <td colspan="3">산재보험 (개인부담분)</td>
            <td class="red--text" colspan="2">{{ toPercent(detailData.industrialAccidentInsuranceRate, 2) }}</td>
            <td class="num-text" colspan="3">{{ inputComma(detailData.realIndustrialAccidentInsuranceAmount) }}</td>
          </tr>
          <tr>
            <td colspan="10"></td>
          </tr>
          <tr>
            <th class="yellow-row" colspan="2">지급정보</th>
            <th class="yellow-row" colspan="1">예금주</th>
            <th class="yellow-row" colspan="1">{{ detailData.memberNm }}</th>
            <th class="yellow-row" colspan="1">은행</th>
            <th class="yellow-row" colspan="1">{{ detailData.bankNm }}은행</th>
            <th class="yellow-row" colspan="1">계좌번호</th>
            <th class="yellow-row" colspan="3">{{ setBankAccountMasking(detailData.bankAccount) }}</th>
          </tr>
          <tr>
            <th class="etc" rowspan="5" colspan="10">
              ** 비고 **<br/>
              <span class="red--text">실수령액이 (-) 일경우 법인계좌로 입금요청드립니다.</span><br/><br/>
              <span class="company t1">예금주 : 인카모기지 주식회사</span>
              <span class="company t2">은행 : {{ detailData.companyBankNm }}</span>
              <span class="company t2">계좌번호 : {{ detailData.companyBankAccount }}</span>
            </th>
          </tr>
        </table>
      </div>
    </div>
  </v-layout>
</template>

<script>
import TableMixin from "@/mixin/TableMixin";
import DateMixin from "@/mixin/DateMixin";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
// import CryptoJS from "crypto-js";
// import { createSecureHtmlTemplate } from "./secureHtmlTemplate";

export default {
  name: "PaymentDetail",
  props: ["detailTitle", "memberInfo", "detailData", "isCreatePdf"],
  mixins: [TableMixin, DateMixin],
  data() {
    return {

    }
  },
  watch: {
    isCreatePdf(value) {
      if (value) {
        this.createPDF();
      }
    }
  },
  methods: {
    checkMgrYn(value) {
      if (!value) return "";
      return value === "Y" ? "O" : "";
    },
    async createPDF() {
      try {
        const element = document.querySelector(".detail-layout");
        if (!element) {
          this.showAlert({ message: "관리자에게 문의 해주세요." });
          return false;
        }

        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          logging: false,
          scrollY: -window.scrollY
        });

        const imgData = canvas.toDataURL("image/jpeg");

        const doc = new jsPDF({
          orientation: "p",
          unit: "mm",
          format: "a4",
          compress: true
        });
        const imgProps = doc.getImageProperties(imgData);
        const pdfWidth = doc.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        doc.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);

        const baseYm = this.getPrevMonthText(this.detailData.paymentYmd);
        const fileName = `${baseYm}_수수료명세서_${this.detailData.memberNm}.pdf`;
        doc.save(fileName);

        // 암호화 파일용 html 코드 주석
        // const pdfBase64 = doc.output("datauristring").split(",")[1];
        //
        // const password = this.detailData.ssno
        //     ? this.detailData.ssno.substring(0, 6)
        //     : "1234";
        //
        // const encrypted = CryptoJS.AES.encrypt(pdfBase64, password).toString();
        //
        // const htmlContent = createSecureHtmlTemplate(
        //     encrypted,
        //     "급여명세서"
        // );
        //
        // const fileName = `급여명세서_${this.detailData.memberNm}.html`;
        // this.downloadHtml(htmlContent, fileName);

      } catch (error) {
        await this.showAlert({ message: "PDF 생성 중 오류 발생", error});
      }
    },
    getPrevMonthText(baseYm) {
      const year = Number(baseYm.slice(0, 4));
      const month = Number(baseYm.slice(4, 6));

      const date = new Date(year, month - 1);

      date.setMonth(date.getMonth() - 1);
      const prevYear = date.getFullYear();
      const prevMonth = date.getMonth() + 1;
      return `${prevYear}년${prevMonth}월`
    }
    // 암호화 파일용 html 코드 주석
    // downloadHtml(content, fileName) {
    //   const blob = new Blob([content], { type: "text/html" });
    //   const link = document.createElement("a");
    //   link.href = URL.createObjectURL(blob);
    //   link.download = fileName;
    //   link.click();
    //   URL.revokeObjectURL(link.href);
    // }
  }
}
</script>

<style lang="scss" scoped>
.detail-layout {
  border: 2px solid #222222;
  width: 210mm;
  height: 297mm;
  margin: 5px auto;
  padding: 5mm;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .detail-title {
    flex-shrink: 0;
    margin-bottom: 5px;
    span {
      font-size: 1.15rem;
      font-weight: 700;
    }
  }

  .detail-blue-layout {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    span {
      font-size: 0.95rem;
      color: #1772C7;
      font-weight: 600;
    }
  }
  .detail-table-layout {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    word-break: break-all;
    table {
      width: 100%;
      border-collapse: collapse;
      border-left: 0.5px solid #444444;
      border-bottom: 0.5px solid #444444;
      tr {
        th,
        td {
          border: 0.5px solid #444444;
          font-size: 0.85rem;
          text-align: center;
          height: 25px;
          padding: 2px 4px;
        }
        .not-border-bottom {
          border-bottom: none;
        }
        .not-border-top {
          border-top: none;
        }
        .t-1 {
          width: 10%;
        }
        .t-2 {
          width: 20%;
        }
        .t-3 {
          width: 30%;
        }
        .etc {
          text-align: left;
          height: 150px;
        }
        .num-text {
          text-align: right;
        }
        .grey-row {
          background-color: #cdd3dd;
        }
        .yellow-row {
          background-color: rgba(255, 222, 143, 0.79);
        }
        .red-row {
          background-color: rgba(255, 185, 185, 0.78);
        }
        .blue-row {
          background-color: rgba(170, 213, 255, 0.71);
        }
        th {
          span.company {
            background-color: rgb(163, 225, 157);
            text-align: center;
            font-size: 0.95rem;
          }
          .t1 {
           padding: 2px 10px;
          }
          .t2 {
            padding: 2px 20px;
          }
        }
      }
    }
  }
}
</style>